import { useEffect, useState } from "react";
import FloatingBottom from "../../../common/components/FloatingBottom/FloatingBottom";

// Internal Imports
import TypeQuestionModel from "../../../common/components/TypeQuestionModel/TypeQuestionModel";
import { COLORS } from "../../../common/constants/colors";
import { canFormQuestionGoNext, getCopyOf, initialFormQuestion } from "../../../common/constants/Utilities";
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import useListTypeQuestion from "../../../hooks/useListTypeQuestion";
import { IFormQuestion } from "../../../interfaces/IForm";
import '../Formularios.css';

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}

const StepThree = ({ setCanGoNext, mode }: Props) => {

    // States
    const { formQuestion, setFormQuestion, setStatusFormQuestion } = useForm();
    const { listTypeQuestion } = useListTypeQuestion();

    const pushQuestion = (list: IFormQuestion[]) => {
        setFormQuestion({
            ...formQuestion!,
            pregunta: list
        })
    }

    const addQuestion = () => {
        const item = getCopyOf(initialFormQuestion);
        pushQuestion([...formQuestion?.pregunta!, item]);
    }

    useEffect(() => {
        if (canFormQuestionGoNext(formQuestion!)) {
            setCanGoNext(true);
            setStatusFormQuestion(true);
        } else {
            setCanGoNext(false);
            setStatusFormQuestion(false);
        }

    }, [formQuestion?.pregunta])


    return (
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', position: 'relative', minHeight: '50px' }}>
            {formQuestion?.pregunta?.map((question, index) =>
                <TypeQuestionModel
                    key={index + "question"}
                    index={index}
                    question={question}
                    mode={mode}
                    questionList={formQuestion?.pregunta!}
                    onChange={pushQuestion}
                    typesQuestion={listTypeQuestion}
                />
            )}
            <FloatingBottom
                icon={"+"}
                method={addQuestion}
                iconSize={"1.5em"}
                backgroundColor={COLORS.blue_active}
                color={COLORS.white_color1}
                size={"40px"}
                style={{ position: 'absolute', right: '0px', bottom: '0px' }}
            />
        </div>

    );
}

export default StepThree;